import $ from 'jquery';

document.addEventListener('DOMContentLoaded', function() {

    
    // Subscribe form variation (footer)
    
    (function calloutFooterForm() {
        let wrapper = document.createElement('div');
        let emailField = document.querySelector('.js-callout-footer .gfield--type-email');
        let submitButton = document.querySelector('.js-callout-footer .gfield--type-submit');

        wrapper.classList.add('gfield-combo-wrapper');
        
        if ( emailField && submitButton ) {
            emailField.parentNode.insertBefore(wrapper, emailField);
            wrapper.appendChild(emailField);
            wrapper.appendChild(submitButton);
        }
    })();

    // Subscribe form variation (wide)
    // Email and submit button in one row

    (function calloutWideForm() {
        let wrapper = document.createElement('div');
        let emailField = document.querySelector('.js-callout-subscribe-wide .gfield--type-email');
        let checkboxField = document.querySelector('.js-callout-subscribe-wide .gfield--type-checkbox');
        let submitButton = document.querySelector('.js-callout-subscribe-wide .gfield--type-submit');

        wrapper.classList.add('gfield-combo-wrapper');

        if ( emailField && submitButton ) {

            emailField.parentNode.insertBefore(wrapper, emailField);
            wrapper.appendChild(emailField);
            wrapper.appendChild(submitButton);
            wrapper.appendChild(checkboxField);
    
            function rearrangeWideGF() {
                if ( window.innerWidth < 768 ) {
                    wrapper.insertBefore(checkboxField, submitButton);
                } else {
                    wrapper.insertBefore(submitButton, checkboxField);
                }
            }
    
            window.addEventListener('load', rearrangeWideGF);
            window.addEventListener('resize', rearrangeWideGF);
        }

    })();



    // Subscribe form variation (narrow)
    // Email and submit button in two rows
    (function calloutNarrowForm() {
        let wrapper = document.createElement('div');
        let emailField = document.querySelector('.js-callout-subscribe-narrow .gfield--type-email');
        let checkboxField = document.querySelector('.js-callout-subscribe-narrow .gfield--type-checkbox');
        let submitButton = document.querySelector('.js-callout-subscribe-narrow .gfield--type-submit');

        wrapper.classList.add('gfield-combo-wrapper');

        if ( emailField && submitButton ) {

            emailField.parentNode.insertBefore(wrapper, emailField);
            wrapper.appendChild(emailField);
            wrapper.appendChild(submitButton);
            wrapper.appendChild(checkboxField);
            
            function rearrangeNarrowGF() {
                wrapper.insertBefore(checkboxField, submitButton);
            }
    
            window.addEventListener('load', rearrangeNarrowGF);
            window.addEventListener('resize', rearrangeNarrowGF);
        }

    })();
});

$(document).on('gform_confirmation_loaded', function (event, formId){
    // Function to check if 'entry_id' is in the URL query string
    function hasEntryIdParameter() {
        var queryParams = new URLSearchParams(window.location.search);
        return queryParams.has('entry_id');
    }

    // Only run the code if 'entry_id' is not in the URL
    if (!hasEntryIdParameter()) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'g_form_submit',
            'form_id': formId
        });
    }
});
